import * as actionTypes from "./../../actionTypes";
import AuthService from "./../../services/authService";
import {
    apiAdminUrl,
    apiBaseUrl,
    apiMediaUrl,
    WebDomain,
} from "./../../common";
import swal from "sweetalert";
import axios from "axios";

const handleResponse = (response) => {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 405) {
                swal({
                    title: "Expired!",
                    text: "Your session is expired!",
                    icon: "error",
                });
                localStorage.removeItem("token");
                window.location.href = `https://${WebDomain}`;
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
};

export const RecentCallListing = (reload = true) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: reload });
        const request = new Request(
            `${apiBaseUrl}/userPanel/call-history-new`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_RECENT_CALL_LISTING,
                        payload: data.data,
                    });
                    dispatch({
                        type: actionTypes.CALL_LISTING_COUNT,
                        payload: data.count,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const IndividualContactCallHistory = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/Individual-contact-call-history`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.INDIVIDUAL_CONTACT_CALL_HISTORY,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const AllRecordingListing = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/call-recording-list`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_ALL_RECORDING_LISTING,
                        payload: data.data,
                    });
                    dispatch({
                        type: actionTypes.ALL_RECORDING_COUNT,
                        payload: data.count,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const UploadFiles = (imageFile, value) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        let request;
        let formData = new FormData();
        formData.append("recording_filename", imageFile);
        formData.append("upload_type", value);
        request = {
            method: "POST",
            url: `${apiMediaUrl}userPanel/image_upload`,
            headers: {
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            },
            data: formData,
        };

        return axios(request)
            .then((data) => {
                const { data: { url = "", duration = 0, size = 0 } = {} } =
                    data;
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                return { code: 1, file_path: url, duration, size };
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (error && error.response && error.response.data) {
                    swal({
                        title: "Error!",
                        text: error.data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                } else {
                    swal({
                        title: "Error!",
                        text: error.data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            });
    };
};

export const VoicemailListing = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/voicemail-list`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_VOICEMAIL_LISTING,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const DeleteVoicemailFile = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/delete-voicemail`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const DestinationNumber = (value) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.DESTINATION_NUMBER,
            payload: value,
        });
    };
};

export const CallDetails = (value) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.FETCH_CALL_DETAILS,
            payload: value,
        });
    };
};

export const DestinationList = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/call-history-info`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_ALL_DESTINATION_LISTING,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const SendMessage = (params, page) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/send-sms`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    page === "SMSPage"
                        ? swal({
                              title: "Success!",
                              text: "Message sent successfully.",
                              icon: "success",
                          })
                        : "";
                    APP.store.dispatch(SMSChatListing());
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const SMSChatListing = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/sms-chat-list`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_SMS_CHAT_LISTING,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const SMSChatHistory = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/sms-chat-history`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_SMS_CHAT_HISTORY,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const SendSms = (params, loader = true) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: loader });
        const request = new Request(`${apiBaseUrl}/userPanel/send-message`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.TOASTR,
                        payload: {
                            duration: 1500,
                            message: data.ResponseText,
                            type: "success",
                        },
                    });
                    return 1;
                } else {
                    dispatch({
                        type: actionTypes.TOASTR,
                        payload: {
                            duration: 1500,
                            message: data.ResponseText,
                            type: "error",
                        },
                    });
                    return 0;
                }
            })
            .catch(() => {
                dispatch({
                    type: actionTypes.TOASTR,
                    payload: {
                        duration: 1500,
                        message: "Error in sending message",
                        type: "error",
                    },
                });
            });
    };
};

export const AssignedNumberToExtension = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/assign-to-extension`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: "Number Assigned Successfully",
                        icon: "success",
                    });
                    dispatch(FetchAssignedNumberList({ number: params.phone }));
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const FetchAssignedNumberList = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/assign-to-extension-list`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_ASSIGNED_NUMBER_LIST,
                        payload: data.data,
                    });
                    dispatch({
                        type: actionTypes.FETCH_ISTAGGED_NUMBER,
                        payload: data.isTagged,
                    });
                }
                return 1;
            })
            .catch(() => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const DeleteAssignedNumber = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/delete-assign`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: "Number Assigned Deleted Successfully",
                        icon: "success",
                    });
                    dispatch(FetchAssignedNumberList({ number: params.phone }));
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const DeleteTagFromNumber = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/delete-assign-tag`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: "Tag deleted successfully",
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const ScheduleCallTime = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/create-schedule-call`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: "Call Scheduled Successfully",
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const ScheduledCallListing = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/schedule-call-listing`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_SCHEDULED_CALL_LISTING,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const InviteCustomer = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}/userPanel/invite-user`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const CreateNotes = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/create-notes`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.TOASTR,
                        payload: {
                            duration: 1500,
                            message: data.ResponseText,
                            type: "success",
                        },
                    });
                } else {
                    dispatch({
                        type: actionTypes.TOASTR,
                        payload: {
                            duration: 1500,
                            message: data.ResponseText,
                            type: "error",
                        },
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: actionTypes.TOASTR,
                    payload: { duration: 1500, message: error, type: "error" },
                });
            });
    };
};

export const NotesListing = (params, loader = true) => {
    const token = AuthService.getUserAccessToken();
    const user_details = AuthService.getUserDetail();
    let user_type = user_details?.type ?? "";
    let panel =
        user_type === "C" ? "userPanel" : user_type === "E" ? "agentPanel" : "";
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: loader });
        const request = new Request(
            `${apiBaseUrl}/${panel}/profile-info_data`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_NOTES_LISTING,
                        payload: data.data?.notes ?? [],
                    });
                    dispatch({
                        type: actionTypes.FETCH_PROFILE_INFO_DATA,
                        payload: data.data ?? {},
                    });
                } else {
                    dispatch({
                        type: actionTypes.TOASTR,
                        payload: {
                            duration: 1500,
                            message: data.ResponseText,
                            type: "error",
                        },
                    });
                    dispatch({
                        type: actionTypes.FETCH_NOTES_LISTING,
                        payload: [],
                    });
                    dispatch({
                        type: actionTypes.FETCH_PROFILE_INFO_DATA,
                        payload: {},
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: actionTypes.TOASTR,
                    payload: { duration: 1500, message: error, type: "error" },
                });
                dispatch({
                    type: actionTypes.FETCH_NOTES_LISTING,
                    payload: [],
                });
                dispatch({
                    type: actionTypes.FETCH_PROFILE_INFO_DATA,
                    payload: {},
                });
            });
    };
};

export const ForceCall = (number) => {
    return APP.store.dispatch({
        type: actionTypes.FORCE_CALL,
        payload: number,
    });
};

export const ForceOpenDialPad = (data) => {
    return APP.store.dispatch({
        type: actionTypes.FORCE_OPEN_DIALPAD,
        payload: data,
    });
};

export const TagCalleeNumber = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/create-tag`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    dispatch(FetchAssignedNumberList({ number: params.phone }));
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const TaggedNumberListing = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/tag-list`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_TAGGED_NUMBER_LISTING,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const NewMessageCount = (count) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.NEW_MESSAGE_COUNT,
            payload: count,
        });
    };
};

export const FetchPlannerDetails = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/planner-listing`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_PLANNER_DETAILS,
                        payload: data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const FetchOutNumber = (phone, loader = true) => {
    const token = AuthService.getUserAccessToken();
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: loader });
    const request = new Request(`${apiBaseUrl}/userPanel/fetch-contact-name`, {
        method: "POST",
        body: JSON.stringify({ phone }),
        headers: new Headers({
            "Content-Type": "application/json",
            "X-Auth-Token": token,
        }),
    });
    return fetch(request)
        .then(handleResponse)
        .then((data) => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            if (data.ResponseCode === "1") {
                return data.data.name;
            } else {
                return phone;
            }
        })
        .catch(() => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            return phone;
        });
};

export const FetchOutInfo = (phone, loader = true) => {
    const token = AuthService.getUserAccessToken();
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: loader });
    const request = new Request(`${apiBaseUrl}/userPanel/fetch-contact-info`, {
        method: "POST",
        body: JSON.stringify({ phone }),
        headers: new Headers({
            "Content-Type": "application/json",
            "X-Auth-Token": token,
        }),
    });
    return fetch(request)
        .then(handleResponse)
        .then((data) => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            if (data.ResponseCode === "1") {
                return data.data.app_picture;
            } else {
                return "public/assets/images/icons/2.svg";
            }
        })
        .catch(() => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            return "public/assets/images/icons/2.svg";
        });
};

export const FetchHistoryIndividual = (number, loader = true) => {
    const token = AuthService.getUserAccessToken();
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: loader });
    const request = new Request(
        `${apiBaseUrl}userPanel/Individual-contact-call-history `,
        {
            method: "POST",
            body: JSON.stringify({ number }),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        }
    );
    return fetch(request)
        .then(handleResponse)
        .then((data) => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            if (data.ResponseCode === "1") {
                return { code: 1, response: data.data };
            } else {
                return { code: 0, response: data.ResponseText };
            }
        })
        .catch(() => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            return { code: 0 };
        });
};

export const Authorized_User = (value) => {
    APP.store.dispatch({ type: actionTypes.AUTHORIZED_USER, payload: value });
};

export const TagListing = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/nxa-tag-list`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.GET_TAG_LISTING,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const AddTag = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/add-nxa-tag`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    dispatch(TagListing());
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const DeleteTag = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/delete-nxa-tag`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    dispatch(TagListing());
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const AssignTag = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/assign-tag`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const OnBoardProcessStatics = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        const request = new Request(
            `${apiBaseUrl}/userPanel/welcome-screen-api`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_ONBOARD_PROCESS_STATICS,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {});
    };
};
